import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface FinancialFilterProps {
  period: "month" | "quarter" | "year";
  setPeriod: (period: "month" | "quarter" | "year") => void;
  startDate: string;
  setStartDate: (date: string) => void;
  endDate: string;
  setEndDate: (date: string) => void;
}

export function FinancialFilter({
  period,
  setPeriod,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
}: FinancialFilterProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <div className="space-y-2">
        <Label className="text-white">Período</Label>
        <Select value={period} onValueChange={(value: "month" | "quarter" | "year") => setPeriod(value)}>
          <SelectTrigger className="bg-[#222831] text-white border-[#404040]">
            <SelectValue placeholder="Selecione o período" />
          </SelectTrigger>
          <SelectContent className="bg-[#1A1F2C] text-white border-[#404040]">
            <SelectItem value="month">Mensal</SelectItem>
            <SelectItem value="quarter">Trimestral</SelectItem>
            <SelectItem value="year">Anual</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-2">
        <Label className="text-white">Data Inicial</Label>
        <Input
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          className="bg-[#222831] text-white border-[#404040]"
        />
      </div>

      <div className="space-y-2">
        <Label className="text-white">Data Final</Label>
        <Input
          type="date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          className="bg-[#222831] text-white border-[#404040]"
        />
      </div>
    </div>
  );
}